import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Button, ButtonToolbar, Modal } from 'reactstrap';
import { reduxForm } from 'redux-form';
import { withTranslation } from 'react-i18next';
import CreatableSelect from 'react-select/lib/Creatable';

// import EyeIcon from 'mdi-react/EyeIcon';
// import renderSelectField from '../../../shared/components/form/Select';
import global from '../../../global';
import Alert from '../../../shared/components/Alert';
import SelectService from '../../../services/SelectService';

class CustomersModal extends PureComponent {
  static propTypes = {
    title: PropTypes.string,
    modal: PropTypes.bool,
    // showPassField: PropTypes.bool,
    toggle: PropTypes.func.isRequired,
    handleChange: PropTypes.func.isRequired,
    postValue: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.shape({
        value: PropTypes.string,
        label: PropTypes.string,
      }),
    ]),
    handleSubmit: PropTypes.func,
    errorMsg: PropTypes.string,
  };

  static defaultProps = {
    title: 'User',
    modal: false,
    // showPassField: true,
    postValue: {},
    errorMsg: '',
    handleSubmit: (e) => {
      e.preventDefault();
      console.log('submitted');
    },
  };

  constructor(props) {
    super(props);
    this.state = {
      // showPassword: false,
      locType: 0,
    };
    this.isLoading = false;
    this.toggle = this.toggle.bind(this);
    this.userdata = JSON.parse(localStorage.getItem('userData'));
  }

  componentDidMount() {
    this.isLoading = true;
  }

  componentWillUnmount() {
    this.isLoading = false;
  }

  getOptions = async (newValue) => {
    const { locType } = this.state;
    const formData = { searchFor: newValue, searchType: locType };
    const options = [];
    if (this.isLoading) {
      await SelectService.listUserLocationOptions(formData).then((response) => {
        if (response) {
          response.map(opt => (
            options.push({
              label: opt.location_name,
              value: opt.location_id,
            })
          ));
        }
      }).catch((error) => {
        console.log('Error: ', error.message);
      });
    }

    this.isLoading = false;
    this.setState({ options });
  }

  handleSelectChange = (e) => {
    const { log } = console;
    const { props } = this;
    log(props.postValue);

    const type = e.target.value;
    const { handleChange } = this.props;

    this.setState({ locType: type });
    this.isLoading = true;
    handleChange(e, 'locationType');
    setTimeout(() => {
      this.getOptions('');
    }, 100);
  }

  // showPassword = (e) => {
  //   e.preventDefault();
  //   this.setState(prevState => ({ showPassword: !prevState.showPassword }));
  // };

  toggle() {
    this.setState(prevState => ({ modal: !prevState.modal }));
  }

  render() {
    const {
      title, toggle, modal, postValue, errorMsg, handleChange, handleSubmit,
      // title, toggle, modal, showPassField, postValue, errorMsg, handleChange, handleSubmit,
    } = this.props;
    const { options } = this.state;
    const { customerType } = global;
    let userTypeObj = customerType;

    // remove admin if user type is 5 (office)
    if (this.userdata.type === '5') {
      userTypeObj = Object.keys(customerType).reduce((object, key) => {
        if (key !== '1') {
          object[key] = customerType[key];
        }
        return object;
      }, {});
    }

    return (
      <div>
        <Modal
          isOpen={modal}
          className="modal-dialog--primary modal-dialog--header"
        >
          <div className="modal__header bg_blue">
            <button className="lnr lnr-cross modal__close-btn" type="button" onClick={toggle} />
            <h4 className="bold-text  modal__title">{title.toString()}</h4>
          </div>
          <form onSubmit={handleSubmit}>
            <div className="modal__body p-t-10">
              { errorMsg && (
                <div className="notif_msg">
                  <Alert color="danger" className="alert--colored">
                    <p><span className="fa fa-exclamation">&nbsp;</span> { errorMsg }</p>
                  </Alert>
                </div>
                )
              }
              <div className="form form--horizontal m-t-10">
                <div className="form__form-group">
                  <span className="form__form-group-label">Name <b className="text-danger">*</b></span>
                  <div className="form__form-group-field">
                    <input type="text" name="name" value={postValue.name ? postValue.name : ''} placeholder="Name" onChange={e => handleChange(e, 'name')} />
                    <input type="hidden" name="user_id" value={this.userdata.user_id} />
                  </div>
                </div>


                {
                  title !== 'Edit Customer' ? (
                    <div className="form__form-group">
                      <span className="form__form-group-label">Current Balance  <b className="text-danger">*</b></span>
                      <div className="form__form-group-field">
                        <input type="number" name="currentBalance" value={postValue.currentBalance ? postValue.currentBalance : ''} placeholder="Current Balance" onChange={e => handleChange(e, 'currentBalance')} />
                      </div>
                    </div>
                  ) : ''
                }

                <div className="form__form-group">
                  <span className="form__form-group-label">Customer Code <b className="text-danger">*</b></span>
                  <div className="form__form-group-field">
                    <input type="text" name="number" value={postValue.number ? postValue.number : ''} placeholder="Customer Code" onChange={e => handleChange(e, 'number')} />
                  </div>
                </div>

                {
                  title === 'Edit Customer' ? (
                  <div className="form__form-group">
                    <span className="form__form-group-label">Customer Balance <b className="text-danger">*</b></span>
                    <div className="form__form-group-field">
                      <input type="text" name="current_balance" value={postValue.current_balance ? postValue.current_balance : ''} placeholder="Customer Code" onChange={e => handleChange(e, 'current_balance')} />
                    </div>
                  </div>
                  ) : ''
                }

                {
                  title !== 'Edit Customer' && ['1', '5'].indexOf(this.userdata.type) !== -1 ? (
                  <div className="form__form-group">
                    <span className="form__form-group-label">Type <b className="text-danger">*</b></span>
                    <div className="form__form-group-field">
                      <select name="type" value={postValue.type ? postValue.type : ''} onChange={this.handleSelectChange}>
                        <option value="">-- Select --</option>
                        {
                          Object.keys(userTypeObj).map(k => (
                            <option key={k} value={k}>{userTypeObj[k]}</option>
                          ))
                        }
                      </select>
                    </div>
                  </div>
                  ) : ''
                }
                {
                  postValue.type && parseInt(postValue.type, 10) !== 1 ? (
                    <div className="form__form-group">
                      <span className="form__form-group-label">Location <b className="text-danger">*</b></span>
                      <div className="form__form-group-field">
                        <div className="form__form-group-input-wrap">
                          <CreatableSelect
                            name="location"
                            value={{
                              label: postValue.locationName ? postValue.locationName : '',
                              value: postValue.location ? postValue.location : '',
                            }}
                            cacheOptions
                            options={options}
                            onChange={e => handleChange(e, 'location')}
                            className="react-select"
                            classNamePrefix="react-select"
                            placeholder="Select location"
                            isValidNewOption={() => false}
                          />
                        </div>
                      </div>
                    </div>
                  ) : ''
                }
              </div>
            </div>
            <ButtonToolbar className="modal__footer">
              <Button color="primary">Submit</Button>
              <Button onClick={toggle}>Cancel</Button>
            </ButtonToolbar>
          </form>
        </Modal>
      </div>
    );
  }
}

export default reduxForm({
  form: 'userForm', // a unique identifier for this form
})(withTranslation('common')(CustomersModal));
